import { Container, Grid, makeStyles, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";

export default function Privacy()
{
    

    const styles ={
        Subtitle: {
            fontWeight:'bold',
            lineHeight:1.8,
            letterSpacing:0.7,
            color:'#212121',
            textTransform:'uppercase'
        },
        Text:{
            lineHeight:1.8,
            letterSpacing:0.7,
            color:'#212121',
            textAlign:'justify'
        },
        highlighted : {
            color:'#212121',
            fontWeight:'bold'
        },
    };

    // Definimos un estilo base para las celdas de contenido
    const contentCellSx = {
        whiteSpace: 'normal', // Habilitar el ajuste de texto
        wordBreak: 'break-word', // Romper palabras largas si es necesario
        // Usamos align="left" para el contenido, a menos que sea un número/fecha
        textAlign: 'left', 
    };

    function createData(name, sharedData, purpose) {
        return { name, sharedData,purpose };
    }

    const rows6A = [
        createData(
            'Comercios y Proveedores de los Productos/Servicios (Tiendas/Restaurantes)',
            'Nombre completo del Usuario, Dirección de Entrega y Teléfono de Contacto.',
            'Necesario para la preparación y entrega de los pedidos solicitados a través de la Plataforma, garantizando la correcta ejecución del servicio.'
        ),
        createData(
            'Repartidores Independientes',
            'Nombre del Usuario, Dirección de Entrega y Ubicación GPS actual (solo durante la entrega activa).',
            'Permitir el rastreo del pedido y la coordinación de la entrega final en el punto de destino.'
        ),
        createData(
            'Proveedores de Servicios de Pago Electrónico',
            'Monto de la Transacción, detalles del Método de Pago (tokenizado).',
            'Procesar los pagos de forma segura. QUD no almacena los datos completos de su tarjeta de crédito.'
        ),
    ];

    const rows6B = [
        createData(
            'Proveedores de Sistemas CRM / Call Center',
            'Nombre, Correo Electrónico, Historial de Pedidos y Comunicaciones.',
            'Ofrecer un Servicio de Atención al Cliente de calidad y medir el grado de satisfacción.'
        ),
        createData(
            'Plataformas de Control de Fraude y Seguridad',
            'Dirección IP, Identificador Único del Dispositivo, e Historial de Transacciones.',
            'Detectar, investigar y prevenir actividades fraudulentas, garantizando la seguridad en el uso de la Plataforma (Apartado 4).'
        )
    ];

    return(
        <Container maxWidth='lg' sx={{mt:20,mb:10}}>
            <Grid container spacing={3}>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <Typography variant="h4">Políticas de privacidad</Typography>
                    <Typography mt={5} variant='body1' gutterBottom>
                        Estas políticas de privacidad explican nuestras prácticas (y sus elecciones) con respecto a la recopilación, el uso y la divulgación de ciertos datos, incluida su información personal en relación con el servicio de QUD.
                    </Typography>

                    {/**CONTACTO */}
                    <Typography mt={5} variant='body1' style={styles.Subtitle}>
                        Contacto
                    </Typography>
                    <Typography mt={2} variant='subtitle1' paragraph style={styles.Text}>
                        Si tiene preguntas generales sobre su cuenta o cómo ponerse en contacto con nuestro Servicio al Cliente para obtener asistencia, 
                        si tiene alguna pregunta específica respecto de esta Declaración de privacidad, o nuestro uso de su información personal, de las 
                        cookies o de otras tecnologías similares, escriba a nuestro responsable de Protección de Datos o a la Oficina de Privacidad al email 
                        &nbsp;<span style={styles.highlighted}>support@qud.life</span>.
                    </Typography>

                    <Typography mt={2} variant='subtitle1' paragraph  style={styles.Text}>
                        El responsable del tratamiento de los datos de su información personal es <sapn style={styles.highlighted}>Technological Sharks CA</sapn> de ahora en adelante QUD. Tenga en cuenta que, si se comunica con nosotros para obtener ayuda, tanto por su seguridad como por la nuestra, podemos pedirle que autentique su identidad antes de atender su solicitud.
                    </Typography>


                    <br/>
                    <br/>
                    {/**RECOPILACION DE INFORMACION */}
                    <Typography variant='body1' style={styles.Subtitle}>
                        Recopilación de la información
                    </Typography>

                    <Typography variant='subtitle1' paragraph  style={styles.Text}>
                        A través de este sitio web no se recaban datos de carácter personal de los usuarios sin su conocimiento, 
                        ni se ceden a terceros. Toda comunicación con QUD por cualquier medio o a través de su dirección de correo 
                        electrónico, o de los formularios presentes en este sitio web o a su e-mail, supone el consentimiento expreso para que sus datos personales en calidad de Cliente/Proveedor/Contacto/Repartidor, sean incorporados en nuestro Registro de Actividades y a ficheros o bases de datos titularidad de Technological Sharks, que usted puede consultar y se conservarán mientras se mantenga la relación o durante los años necesarios para cumplir con las obligaciones legales. 
                    </Typography>

                    <Typography paragraph  style={styles.Text}>
                        Los datos de carácter personal que se pudieran recabar directamente del interesado serán tratados de forma 
                        confidencial y quedarán incorporados a la correspondiente actividad de tratamiento. La finalidad del 
                        tratamiento de los datos corresponde a cada una de las actividades de tratamiento que realiza QUD y que 
                        Usted tiene derecho a obtener confirmación sobre si estamos tratando sus datos personales, por tanto, 
                        tiene derecho a acceder a sus datos personales, rectificar los datos inexactos o solicitar que sean rectificados.
                    </Typography>

                    <Typography paragraph  style={styles.Text}>
                        Este documento de Política de Privacidad pauta los términos en que QUD maneja y protege la información que es 
                        proporcionada por sus usuarios al momento de utilizar su plataforma cuyo dominio es <span style={styles.highlighted}>qud.life</span> (que 
                        incluye el formato Web y la “App”), redes sociales o cualquier medio relacionado con la marca. 
                        Estamos comprometidos con la responsabilidad en la seguridad de los datos de nuestros usuarios en concordancia 
                        con las legislaciones locales y las consideraciones éticas correspondientes. Cuando le pedimos llenar los campos
                        de información personal con la cual usted pueda ser identificado, lo hacemos asegurando que sólo se emplea 
                        de acuerdo con los términos de este documento.
                    </Typography>

                    <Typography paragraph  style={styles.Text}>
                        Antes de registrase en QUD, los Usuarios deben leer la presente Política de Privacidad. Al marcar el botón 
                        “registrarse” o su equivalente, los Usuarios afirman que han leído y que consienten expresamente las presente 
                        Política de Privacidad, en particular la finalidad con la que se recopilan los datos, así como cualquier 
                        cesión de datos prevista en la presente Política de Privacidad. Asimismo, QUD, siempre y cuando los Usuarios 
                        lo autoricen, recogerá datos relacionados con su localización y otros requeridos.
                    </Typography>

                    <Typography paragraph  style={styles.Text}>
                        Una vez completado el registro, todo Usuario podrá acceder a su perfil y completarlo y/o editarlo 
                        según estime conveniente. La información y datos facilitados por el Usuario estarán en todo momento 
                        disponibles en su cuenta de usuario y podrán ser modificados por el Usuario a través de la opción 
                        editar perfil.
                    </Typography>

                    <Typography paragraph style={styles.Text}>
                        El Usuario se compromete a introducir datos reales y veraces. Asimismo, será el único responsable 
                        de los daños y perjuicios que QUD, sus aliados o terceros pudieran sufrir como consecuencia de la 
                        falta de veracidad, inexactitud, falta de vigencia y autenticidad de los datos facilitados. Los datos 
                        recabados por QUD, serán exclusivamente utilizados para la consecución del objeto definido en los 
                        términos y condiciones y las condiciones descritas en la presente Política. Toda la información personal 
                        que facilite o se recoja a través de la App y el sitio Web será tratada principalmente por QUD, como 
                        responsable del tratamiento.
                    </Typography>


                    <br/>
                    {/** 1 - LEGISLACION APLICABLE */}
                    <Typography variant='body1' style={styles.Subtitle}>
                        1.LEGISLACIÓN APLICABLE A LOS DATOS PERSONALES DE LOS USUARIOS (PROTECCIÓN DE DATOS DE CARÁCTER PERSONAL): 
                    </Typography>

                    <Typography paragraph style={styles.Text}>
                        QUD tiene el compromiso de cumplir con la legislación vigente en cada momento en materia de 
                        protección de datos y mantenerse actualizado al respecto. Se informa a los usuarios que los 
                        datos de carácter personal que sean facilitados en la plataforma serán objeto de tratamiento 
                        automatizado y pasarán a formar parte de la base de datos de QUD, siendo el responsable del 
                        tratamiento, para las finalidades propias de gestión de usuarios registrados en la Plataforma de QUD.
                    </Typography>



                    <br/><br/>
                    {/** 2 - INFORMACIÓN REQUERID:  */}
                    <Typography variant='body1' style={styles.Subtitle}>
                        2.INFORMACIÓN REQUERIDA
                    </Typography>
                    <div>
                        <Typography paragraph style={styles.Text}>
                            La Plataforma de QUD se utiliza tanto por los Usuarios, como por nuestros Proveedores y repartidores, 
                            los cuales manejan la siguiente información:
                        </Typography>

                        <div style={{marginLeft:20}}>
                            <Typography paragraph style={styles.Text}>
                                <span style={styles.highlighted}>Información que los Usuarios nos facilitan directamente:</span> 
                            </Typography>
                                
                            <div style={{marginLeft:20}}>
                                <Typography paragraph style={styles.Text}>
                                    <span style={{fontWeight:'bold'}}>• Datos de Registro:</span> 
                                    la información que el Usuario nos facilita cuando se crea una cuenta en 
                                    la Plataforma de QUD: nombre del Usuario y el correo electrónico.
                                </Typography>

                                <Typography paragraph style={styles.Text}>
                                    <span style={{fontWeight:'bold'}}>• Información del Perfil del Usuario: </span> 
                                    la información que el Usuario añade en la Plataforma a efectos de poder utilizar el servicio de QUD, 
                                    esto es, el teléfono móvil y la dirección de entrega del Usuario. El Usuario puede ver y editar los 
                                    datos personales de su perfil cuando estime oportuno. QUD no almacena los datos de la tarjeta de crédito 
                                    del Usuario, datos bancarios, pero éstos se facilitan a prestadores de servicios de pago electrónico con 
                                    licencia, los cuales recibirán directamente los datos incluidos y los almacenarán para facilitar el proceso 
                                    de pago al Usuario y gestionarán el mismo en nombre de QUD. En ningún caso QUD almacena en sus servidores 
                                    estos datos. El Usuario podrá, en cualquier momento, eliminar los datos, con esa acción, el proveedor de 
                                    servicios procederá al borrado de los datos y será necesario volver a introducirlos o seleccionarlos para 
                                    poder realizar nuevos pedidos a través de la Plataforma.
                                </Typography>

                                <Typography paragraph style={styles.Text}>
                                    <span style={{fontWeight:'bold'}}>• Información acerca de las comunicaciones realizadas con QUD: </span> 
                                    se tendrá acceso a información que los Usuarios faciliten para la resolución de dudas o quejas 
                                    sobre el uso de la plataforma. 
                                </Typography>

                                <Typography paragraph style={styles.Text}>
                                    El tratamiento de estos datos por parte de QUD es necesario para poder cumplir con la relación 
                                    contractual que se establece. Si el Usuario no los facilita, los servicios solicitados podrán no 
                                    estar disponibles.
                            </Typography>
                            </div>
                        </div>


                        <div style={{marginLeft:20,marginTop:30}}>
                            <Typography paragraph style={styles.Text}>
                                <span style={styles.highlighted}>Información que los Usuarios nos facilitan indirectamente:</span> 
                            </Typography>
                                
                            <div style={{marginLeft:20}}>
                                <Typography paragraph style={styles.Text}>
                                    <span style={{fontWeight:'bold'}}>• Datos de Interacción y Red: </span>
                                    QUD puede recolectar los datos derivados del uso de la Plataforma por parte del Usuario cada vez que éste 
                                    interactúa con la Plataforma, como: Dirección IP de Internet que utiliza el Usuario para conectarse a Internet, 
                                    información de su ordenador o móvil (tipo de navegador, la versión y el sistema operativo, y el tipo de dispositivo). 
                                    El clickstream completo de localizadores de recursos Uniformes (URL), incluyendo la fecha y la hora.
                                </Typography>

                                <Typography paragraph style={styles.Text}>
                                    <span style={{fontWeight:'bold'}}>• Datos de Cuenta y Historial: </span>
                                    La información de los pedidos realizados por parte del Usuario, así como las valoraciones y/o comentarios 
                                    que realice acerca de los mismos. El historial de navegación y las preferencias del Usuario.
                                </Typography>

                                <Typography paragraph style={styles.Text}>
                                    <span style={{fontWeight:'bold'}}>• Datos de Soporte y Cookies: </span>
                                    Datos derivados de la gestión de incidencias (mensajes, audios, o cualquier información que el Usuario 
                                    facilite a través del Formulario de Contacto o números de teléfono para la resolución de dudas o quejas). 
                                    También se recopilan los datos derivados de las "cookies" necesarias para el correcto funcionamiento del 
                                    sitio web y la aplicación.
                                </Typography>
                            </div>
                        </div>

                        <div style={{marginLeft:20,marginTop:30}}>
                            <Typography paragraph style={styles.Text}>
                                <span style={styles.highlighted}>Datos de Hardware y Sensores del Dispositivo</span> 
                            </Typography>
                            <div style={{marginLeft:20}}>
                                <Typography paragraph style={styles.Text}>
                                    <span style={{fontWeight:'bold'}}>• Datos de Hardware del Dispositivo (Cámara): </span>
                                    Recopilamos datos de la funcionalidad de la cámara de su dispositivo ÚNICAMENTE para la lectura 
                                    de códigos QR y códigos de barras, necesarios para la validación de tickets en eventos o la 
                                    confirmación de pedidos. La aplicación no almacena ni transmite fotografías o videos; solo 
                                    procesamos los datos obtenidos del código escaneado.
                                </Typography>

                                <Typography paragraph style={styles.Text}>
                                    <span style={{fontWeight:'bold'}}>• Datos de Localización (GPS): </span>
                                    Recopilamos datos de ubicación geográfica precisa (GPS) de su dispositivo. 
                                    La ubicación se recopila ÚNICAMENTE cuando la aplicación está abierta y en uso (primer plano).
                                </Typography>
                            </div>

                            

                            <Typography paragraph style={styles.Text}>
                                Los datos a los que QUD accede de forma indirecta son necesarios para analizar y mejorar la experiencia de uso 
                                de la Plataforma, garantizar la seguridad de la conexión y, en el caso de la Cámara y la Localización, para la 
                                correcta prestación de los servicios solicitados.
                            </Typography>
                        </div>
                    </div>

                    



                    <br/><br/>
                    {/** 3 - FINALIDAD DE LOS DATOS:   */}
                    <Typography variant='body1' style={styles.Subtitle}>
                        3.FINALIDAD DE LOS DATOS: 
                    </Typography>
                    <div>
                        <Typography paragraph style={styles.Text}>
                            Los datos que QUD recopila de los Usuarios se utilizan para los siguientes fines, siendo todos necesarios para la 
                            prestación de los servicios solicitados a través de la Plataforma, según lo descrito en los “Términos de Uso”:
                        </Typography>
                        {/** 3A. Para la Prestación del Servicio Principal (Uso de Datos Sensibles) */}
                        <div style={{marginLeft:20}}>
                            <Typography paragraph style={styles.Text}>
                                <span style={styles.highlighted}>A. Para la Prestación del Servicio Principal (Uso de Datos Sensibles)</span> 
                            </Typography>
                                
                            <div style={{marginLeft:20}}>
                                <Typography paragraph style={styles.Text}>
                                    <span style={{fontWeight:'bold'}}>• Ejecución del Pedido y Entrega: </span> 
                                    Los datos personales (incluyendo Nombre, Teléfono y Dirección de Entrega) son esenciales para la gestión, 
                                    ejecución y finalización de los pedidos.
                                </Typography>

                                <Typography paragraph style={styles.Text}>
                                    <span style={{fontWeight:'bold'}}>• Localización (GPS): </span> 
                                    Utilizamos los datos de ubicación geográfica precisa (GPS) para Usuarios (determinar la dirección de entrega 
                                    y calcular la distancia de los establecimientos) y para Repartidores (rastrear la ubicación durante la entrega 
                                    activa y optimizar el servicio).
                                </Typography>

                                <Typography paragraph style={styles.Text}>
                                    <span style={{fontWeight:'bold'}}>• Cámara: </span> 
                                    La funcionalidad de la cámara se utiliza para el escaneo de códigos QR y códigos de barras para la validación 
                                    de tickets en eventos o la confirmación de la entrega del pedido, garantizando la seguridad de la transacción.
                                </Typography>

                                <Typography paragraph style={styles.Text}>
                                    <span style={{fontWeight:'bold'}}>• Comunicaciones Operacionales: </span> 
                                    Utilizaremos su correo electrónico y/o teléfono para enviar mensajes (vía email y/o SMS) acerca del estado y 
                                    la operativa de su pedido (confirmación, seguimiento y recibo/resumen final). Al registrarse, el Usuario acepta 
                                    y autoriza expresamente estas comunicaciones.
                                </Typography>
                            </div>
                        </div>

                        {/** 3B. Para la Prestación del Servicio Principal (Uso de Datos Sensibles) */}
                        <div style={{marginLeft:20}}>
                            <Typography paragraph style={styles.Text}>
                                <span style={styles.highlighted}>B. Para el Soporte y Mejora del Servicio</span> 
                            </Typography>
                                
                            <div style={{marginLeft:20}}>
                                <Typography paragraph style={styles.Text}>
                                    <span style={{fontWeight:'bold'}}>• Gestión de Incidencias: </span> 
                                    Los datos facilitados por el Usuario a través del Formulario de Contacto, correos electrónicos o llamadas se utilizan exclusivamente para la resolución de dudas, quejas o la gestión de incidencias presentes o futuras.
                                </Typography>

                                <Typography paragraph style={styles.Text}>
                                    <span style={{fontWeight:'bold'}}>• Mejora y Análisis: </span> 
                                    Utilizamos la información con fines estadísticos para investigar y analizar cómo mejorar los servicios que QUD presta a los Usuarios, gestionar y desarrollar nuevas características, y analizar el comportamiento y las tendencias de uso de la Plataforma.
                                </Typography>
                            </div>
                        </div>

                        {/** 3C. Acceso a Datos por Terceros Operacionales */}
                        <div style={{marginLeft:20}}>
                            <Typography paragraph style={styles.Text}>
                                <span style={styles.highlighted}>C. Acceso a Datos por Terceros Operacionales</span> 
                            </Typography>
                            <Typography paragraph style={styles.Text}>
                                Durante la ejecución de un pedido, nuestros operadores de atención al cliente, Repartidores y los terceros proveedores de servicios que ejecutan la transacción tendrán acceso a la información personal necesaria para realizar sus funciones, pero no podrán utilizarla para otros fines. QUD garantiza que todos sus socios, proveedores y terceros están unidos mediante promesas contractualmente vinculantes para procesar la información siguiendo las indicaciones de esta Política de Privacidad.
                            </Typography>
                                
                            <div style={{marginLeft:20}}>
                                <Typography paragraph style={styles.Text}>
                                    • En el supuesto que el Usuario contacte directamente con los proveedores descritos y facilite sus datos directamente a éstos, QUD no será responsable por el uso que los proveedores hagan de los datos recopilados.
                                </Typography>
                            </div>
                        </div>
                    </div>




                    <br/><br/>
                    {/** 4 - GARANTIZAR LA SEGURIDAD EN LA PRESTACIÓN DE SERVICIOS:    */}
                    <Typography variant='body1' style={styles.Subtitle}>
                        4.GARANTIZAR LA SEGURIDAD EN LA PRESTACIÓN DE SERVICIOS: 
                    </Typography>

                    <Typography style={styles.Text}>
                        Se utilizan los datos a efectos de garantizar el buen uso de los productos solicitados en la 
                        Plataforma (asegurar consejo farmacéutico, garantizar la entrega a mayores de 18 años, entre otros). 
                        Se puede utilizar la información de los Usuarios con el propósito de detectar e investigar fraudes, 
                        así como otras actividades ilegales y quebrantamientos potenciales de nuestros “Términos de Uso”. 
                        QUD podrá compartir datos del usuario con plataformas que analicen las operaciones de fraude. 
                    </Typography>



                    <br/><br/>
                    {/** 5 - PROMOCIÓN Y OFERTAS COMERCIALES:     */}
                    <Typography variant='body1' style={styles.Subtitle}>
                        5.PROMOCIÓN Y OFERTAS COMERCIALES:  
                    </Typography>

                    <Typography style={styles.Text}>
                        QUD podrá utilizar tecnología de terceros integrada en su Plataforma a los efectos de recabar sus 
                        datos y preferencias y utilizarlos con sistemas de CRM y tecnología avanzada en beneficio de los 
                        Usuarios. Así, mediante la información recabada se realizarán los siguientes tratamientos de sus 
                        datos:
                    </Typography>

                    <div style={{marginLeft:20}}>
                        <Typography style={styles.Text}>
                            • Enviar al correo electrónico de los Usuarios mensajes promocionales y/o ofertas relativas al 
                            servicio que ofrece y que pudieran interesar al Usuario. QUD podrá medir y personalizar dicha 
                            publicidad en función de las preferencias de los Usuarios. El Usuario que no desee recibir 
                            información y/o comunicaciones comerciales, podrá optar en cualquier momento a la opción de 
                            “Cancelar la suscripción” en el propio correo electrónico y QUD cesará inmediatamente en el 
                            envío de la citada información.
                        </Typography>

                        <Typography style={styles.Text}>
                            • Se podrá enviar al Usuario a su teléfono móvil mensajes y/u ofertas relativas a dichos servicios.
                        </Typography>

                        <Typography style={styles.Text}>
                            • QUD y/o los terceros asociados con la plataforma, podrán utilizar la dirección de entrega del 
                            pedido introducida por el Usuario a efectos de realizar actividades promocionales para la entrega 
                            de muestras o productos gratuitos del servicio relacionado con QUD (entrega de muestras gratuitas 
                            a domicilio o folletos publicitarios) siempre junto a la entrega del pedido que puedan ser de interés 
                            del Usuario.
                        </Typography>
                    </div>



                    <br/><br/>
                    {/** 6 - COMPARTIR LOS DATOS DE LOS USUARIOS CON TERCEROS:     */}
                    <Typography variant='body1' style={styles.Subtitle}>
                        6.Compartición y Divulgación de los Datos de los Usuarios con Terceros: 
                    </Typography>

                    <Typography paragraph style={styles.Text}>
                        QUD se compromete a no compartir sus datos personales con terceros, excepto cuando sea estrictamente necesario 
                        para la prestación de los servicios solicitados o en el cumplimiento de obligaciones legales. Toda compartición 
                        está sujeta a compromisos de confidencialidad y a esta Política de Privacidad.
                    </Typography>

                    <Typography paragraph style={styles.Text}>
                        La información personal se comparte únicamente con las siguientes categorías de terceros y para los fines específicos 
                        detallados a continuación:
                    </Typography>

                    <div style={{marginLeft:40}}>
                        <Typography paragraph style={styles.Text}>
                            <span style={styles.highlighted}>A. Proveedores y Terceros Operacionales (Para la Ejecución del Pedido)</span> 
                        </Typography>

                        <TableContainer  sx={{ overflowX: 'auto' }}> 
                            <Table aria-label="row6A table">
                                <TableHead>
                                    <TableRow>
                                        {/* Celda 1: Tercero Receptor (Alineación normal) */}
                                        <TableCell sx={{ width: '25%', ...contentCellSx }}>Tercero Receptor</TableCell> 
                                        
                                        {/* Celda 2: Datos Compartidos (Forzamos ajuste y alineación izquierda) */}
                                        <TableCell sx={{ width: '30%', ...contentCellSx }}>Datos Compartidos</TableCell>
                                        
                                        {/* Celda 3: Finalidad Específica (Forzamos ajuste y alineación izquierda) */}
                                        <TableCell sx={{ width: '45%', ...contentCellSx }}>Finalidad Específica</TableCell> 
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {rows6A.map((row) => (
                                        <TableRow
                                            key={row.name}
                                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                        >
                                            {/* Columna 1 */}
                                            <TableCell component="th" scope="row" sx={contentCellSx}>
                                                {row.name}
                                            </TableCell>
                                            {/* Columna 2: Quitamos align="right" */}
                                            <TableCell sx={contentCellSx}>
                                                {row.sharedData}
                                            </TableCell>
                                            {/* Columna 3: Quitamos align="right" */}
                                            <TableCell sx={contentCellSx}>
                                                {row.purpose}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </div>


                    <div style={{marginLeft:40,marginTop:40}}>
                        <Typography paragraph style={styles.Text}>
                            <span style={styles.highlighted}>B. Proveedores de Servicios y Analíticos (Para Soporte y Seguridad)</span>
                        </Typography>

                        <TableContainer  sx={{ overflowX: 'auto' }}> 
                            <Table aria-label="row6A table">
                                <TableHead>
                                    <TableRow>
                                        {/* Celda 1: Tercero Receptor (Alineación normal) */}
                                        <TableCell sx={{ width: '25%', ...contentCellSx }}>Tercero Receptor</TableCell> 
                                        
                                        {/* Celda 2: Datos Compartidos (Forzamos ajuste y alineación izquierda) */}
                                        <TableCell sx={{ width: '30%', ...contentCellSx }}>Datos Compartidos</TableCell>
                                        
                                        {/* Celda 3: Finalidad Específica (Forzamos ajuste y alineación izquierda) */}
                                        <TableCell sx={{ width: '45%', ...contentCellSx }}>Finalidad Específica</TableCell> 
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {rows6B.map((row) => (
                                        <TableRow
                                            key={row.name}
                                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                        >
                                            {/* Columna 1 */}
                                            <TableCell component="th" scope="row" sx={contentCellSx}>
                                                {row.name}
                                            </TableCell>
                                            {/* Columna 2: Quitamos align="right" */}
                                            <TableCell sx={contentCellSx}>
                                                {row.sharedData}
                                            </TableCell>
                                            {/* Columna 3: Quitamos align="right" */}
                                            <TableCell sx={contentCellSx}>
                                                {row.purpose}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </div>

                    <div style={{marginLeft:40,marginTop:40}}>
                        <Typography paragraph style={styles.Text}>
                            <span style={styles.highlighted}>C. Casos Especiales y Legales</span>
                        </Typography>
                        <div style={{marginLeft:20}}>
                            <Typography paragraph style={styles.Text}>
                                • Redes Sociales y Plataformas de Terceros: Si el Usuario conecta su cuenta de QUD a una 
                                red social o plataforma de terceros, QUD utilizará la información cedida por dicha red siempre 
                                que el Usuario lo haya permitido bajo la política de privacidad del tercero.
                            </Typography>
            
                            <Typography paragraph style={styles.Text}>
                                • Transferencia de Propiedad: En caso de que la propiedad de QUD cambie o sea adquirida por un 
                                tercero, informaremos a los Usuarios y transferiremos sus datos a la entidad adquirente con el 
                                único fin de continuar la prestación de los servicios.
                            </Typography>
            
                            <Typography paragraph style={styles.Text}>
                                • Autoridades Competentes: QUD podrá compartir información con organismos o autoridades ejecutivas 
                                previo requerimiento legal y en el ejercicio de sus funciones (para investigar, prevenir o tomar acciones 
                                relativas a presuntas actividades ilegales).
                            </Typography>
                        </div>
                    </div>

                    <Typography paragraph style={styles.Text}>
                        Ninguna de estas comunicaciones de datos incluye utilizar la información personal de clientes 
                        con fines contrarios a los compromisos adquiridos en la presente Política de Privacidad.
                    </Typography>
                    



                    <br/><br/>
                    {/** 7 - DERECHO A RETIRAR SU CONSENTIMIENTO:      */}
                    <Typography variant='body1' style={styles.Subtitle}>
                        7.DERECHO A RETIRAR SU CONSENTIMIENTO:
                    </Typography>

                    <Typography paragraph style={styles.Text}>
                        En cualquier momento el Usuario podrá retirar su consentimiento para el tratamiento de datos por 
                        parte de QUD. Para su retirada bastará con que el Usuario contacte a través de:  support@qud.life 
                    </Typography>

                    <Typography paragraph style={styles.Text}>
                        La retirada del consentimiento podrá realizarse en cualquier momento por parte del interesado. 
                        Los Usuarios aceptan y consienten que la retirada del consentimiento implicará que QUD no pueda 
                        prestar los servicios propios de su Plataforma.
                    </Typography>



                    <br/><br/>
                    {/** 8 - DERECHO A RETIRAR SU CONSENTIMIENTO:      */}
                    <Typography variant='body1' style={styles.Subtitle}>
                        8.PROTECCIÓN DE LOS DATOS DE LOS USUARIOS: 
                    </Typography>

                    <Typography paragraph style={styles.Text}>
                        QUD adopta las medidas necesarias para mantener el nivel de seguridad requerido, según la 
                        naturaleza de los datos personales tratados y las circunstancias del tratamiento, con el 
                        objeto de evitar, en la medida de lo posible y siempre según el estado de la técnica, su 
                        alteración, pérdida, tratamiento o acceso no autorizado. Como se ha mencionado anteriormente, 
                        los datos personales facilitados no serán cedidos a terceros si el titular de los mismos no 
                        hubiera aceptado la presente Política de Privacidad.
                    </Typography>



                    <br/><br/>
                    {/** 9. - CAMBIOS EN POLÍTICAS DE PRIVACIDAD:       */}
                    <Typography variant='body1' style={styles.Subtitle}>
                        9.CAMBIOS EN POLÍTICAS DE PRIVACIDAD:  
                    </Typography>

                    <Typography paragraph style={styles.Text}>
                        QUD se reserva el derecho, a su discreción, de cambiar, modificar, añadir o quitar cualquier 
                        porción de las políticas de privacidad, en cualquier momento. Los cambios serán efectivos cuando 
                        se publiquen. La continuación del uso de la plataforma y/o de los servicios puestos a disposición 
                        después de haber sido publicado cualquier cambio, será considerado como aceptación de esos cambios.
                    </Typography>


                    <br /><br />
                    {/** 10. - INTEGRACIÓN CON WHATSAPP BUSINESS API: */}
                    <Typography variant='body1' style={styles.Subtitle}>
                        10.INTEGRACIÓN CON WHATSAPP BUSINESS API:
                    </Typography>
                    <Typography paragraph style={styles.Text}>
                        QUD utiliza la API de WhatsApp Business para facilitar la comunicación entre los comercios y sus clientes finales. Al utilizar nuestros servicios, usted acepta lo siguiente:
                    </Typography>
                    <div style={{ marginLeft: 20 }}>
                        <Typography paragraph style={styles.Text}>
                            • <strong>Procesamiento de Mensajes:</strong> Las comunicaciones enviadas a través de WhatsApp son procesadas por QUD y pueden ser analizadas por nuestros agentes de Inteligencia Artificial para generar respuestas automatizadas, mejorar la atención al cliente y gestionar pedidos.
                        </Typography>
                        <Typography paragraph style={styles.Text}>
                            • <strong>Cumplimiento de Políticas:</strong> Usted acepta cumplir con las <a href="https://www.whatsapp.com/legal/business-policy/" target="_blank" rel="noreferrer">Políticas de Mensajería de WhatsApp</a>. QUD se reserva el derecho de restringir el acceso a la mensajería si se detecta un uso indebido.
                        </Typography>
                        <Typography paragraph style={styles.Text}>
                            • <strong>Desvinculación:</strong> Los comercios pueden revocar el acceso de QUD a su cuenta de WhatsApp en cualquier momento a través del panel de configuración de su cuenta en QUD, o mediante la gestión de permisos en su cuenta de Meta Business Manager.
                        </Typography>
                        <Typography paragraph style={styles.Text}>
                            • <strong>Responsabilidad:</strong> El comercio es el único responsable del contenido de los mensajes enviados a través de su cuenta de WhatsApp conectada a QUD y de asegurar que cuenta con el consentimiento necesario de sus clientes finales para enviarles dichas comunicaciones.
                        </Typography>
                    </div>


                    <br/><br/>
                    <Typography paragraph style={styles.Text}>
                        Cualquier comentario, información, sugerencia u otro puede comunicarse a través de:  info@qud.life
                    </Typography>

                    <br/><br/>
                    <Typography paragraph style={styles.Text}>
                        <strong>Última actualización:</strong> 05 de julio de 2026
                    </Typography>

                </Grid>
            </Grid>
        </Container>
    )
}



